<script setup lang="ts">
import {onMounted, type PropType, ref, type Ref, watch} from "vue";
import type {Pagination} from "@/app/types";

const page:Ref<number>=ref(1)
const limit:Ref<number>=ref(0)
const emit = defineEmits(["update"])
const props = defineProps({
  pagination: Object as PropType<Pagination>,
  label:String,
  page:Number,
  limit:Number
})

onMounted(() =>{
  if(props?.pagination){
    page.value = props?.page || 1
    limit.value = props?.limit || 0
  }
})

watch(
  () => page.value,
  () => {
    if (props?.pagination && (page.value <= props?.pagination?.totalPages)) {
      emit("update", page.value)
    }
  },
)

</script>

<template>
  <div class="flex">
    <div class="w-full">
      <div class="px-6 py-4 border-t border-gray-200" v-if="pagination && pagination.totalPages > 0">
        <div class="flex items-center justify-between">
          <div class="text-sm text-gray-500">
            Showing {{ (page - 1) * limit + 1 }} to
            {{ Math.min(page * limit, pagination.totalRows) }} of
            {{ pagination.totalRows }} {{label}}
          </div>
          <div class="flex items-center space-x-2">
            <button
              @click="page--"
              :disabled="page === 1"
              class="px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 hover:bg-gray-50 disabled:opacity-50">
              Previous
            </button>
            <button class="px-3 py-1 bg-primary text-white rounded text-sm">
              {{ page }}/{{ pagination?.totalPages }}
            </button>
            <button
              @click="page++"
              :disabled="page > pagination?.totalPages"
              class="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50">
              Next
            </button>
            <label class="px-3 py-1 bg-primary-800 text-white rounded text-sm">{{
                pagination?.totalRows
              }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>